var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaqDarkblue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1573 4.22215C22 5.48327 22 7.23884 22 10.75C22 14.2612 22 16.0167 21.1573 17.2779C20.7926 17.8238 20.3238 18.2926 19.7779 18.6573C18.6762 19.3935 17.1971 19.4865 14.5 19.4983V19.4999L13.118 22.2638C12.6574 23.1851 11.3426 23.1851 10.882 22.2638L9.5 19.4999V19.4983C6.80287 19.4865 5.32384 19.3935 4.22215 18.6573C3.6762 18.2926 3.20744 17.8238 2.84265 17.2779C2 16.0167 2 14.2612 2 10.75C2 7.23884 2 5.48327 2.84265 4.22215C3.20744 3.6762 3.6762 3.20744 4.22215 2.84265C5.48327 2 7.23884 2 10.75 2H13.25C16.7612 2 18.5167 2 19.7779 2.84265C20.3238 3.20744 20.7926 3.6762 21.1573 4.22215Z",
    fill: "#172B4D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7996,
    cy: 10.577,
    r: 1.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 10.577,
    r: 1.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.2,
    cy: 10.577,
    r: 1.2,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaqDarkblue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-faq-darkblue.53343f7bb5190c258c5a28de7d3c0b6e.svg";